import { z } from 'zod';
import { CustomerStatus } from '../../constants/customer-status.js';
import { optionalEditFormTrimmedEmail, optionalEnumIdString, optionalNonNegativeNumberString, optionalUuidString, } from '../zod-helpers/index.js';
import { CUSTOMER_CONSTRAINTS } from './constraints.js';
import { checkCustomerCommercialRequired, checkCustomerIdentity, checkCustomerStatusRequired, } from './rules.js';
export const customerFormFieldsSchema = z.object({
    name: z.string().max(CUSTOMER_CONSTRAINTS.name.maxLength),
    url: z.string().max(CUSTOMER_CONSTRAINTS.url.maxLength),
    note: z.string().max(CUSTOMER_CONSTRAINTS.note.maxLength),
    deliveryPreferences: z.string().max(CUSTOMER_CONSTRAINTS.deliveryPreferences.maxLength),
    email: optionalEditFormTrimmedEmail(CUSTOMER_CONSTRAINTS.email.maxLength, `Invalid ${CUSTOMER_CONSTRAINTS.email.label.toLowerCase()}.`),
    phone: z.string().max(CUSTOMER_CONSTRAINTS.phone.maxLength),
    currencyId: optionalUuidString('Invalid currency selection.'),
    paymentTermsId: optionalUuidString('Invalid payment terms selection.'),
    shipTermsId: optionalUuidString('Invalid ship terms selection.'),
    creditLimit: optionalNonNegativeNumberString(CUSTOMER_CONSTRAINTS.creditLimit.label),
    taxExempt: z.boolean(),
    taxExemptNumber: z.string().max(CUSTOMER_CONSTRAINTS.taxExemptNumber.maxLength),
    taxRateId: optionalUuidString('Invalid tax rate selection.'),
});
export const customerEditFormFieldsSchema = customerFormFieldsSchema.extend({
    statusId: optionalEnumIdString(CustomerStatus, 'Invalid customer status.'),
});
/** A hidden lookup can't be picked, so it isn't required; the mapper leaves it unchanged. */
export const customerEditFormSchemaHiding = (hidden) => customerEditFormFieldsSchema.superRefine((values, context) => {
    for (const issue of checkCustomerIdentity(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
    for (const issue of checkCustomerCommercialRequired(values)) {
        if (hidden.has(issue.path))
            continue;
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
    for (const issue of checkCustomerStatusRequired(values)) {
        context.addIssue({ code: 'custom', message: issue.message, path: [issue.path] });
    }
});
export const customerEditFormSchema = customerEditFormSchemaHiding(new Set());
export const emptyCustomerFormValues = () => ({
    name: '',
    url: '',
    note: '',
    deliveryPreferences: '',
    email: '',
    phone: '',
    currencyId: '',
    paymentTermsId: '',
    shipTermsId: '',
    creditLimit: '',
    taxExempt: false,
    taxExemptNumber: '',
    taxRateId: '',
});
export const emptyCustomerEditFormValues = () => ({
    ...emptyCustomerFormValues(),
    statusId: '',
});
//# sourceMappingURL=update-form.js.map